import {
  CLASS_SIZE_SELECTIONS,
  ClassSizeLearnerAttribute,
} from "../../onboarding/consts";

export const getLabelFromValue = ({
  value,
  selections,
}: {
  value: string;
  selections: {
    value: string;
    label: string;
    [key: string]: any;
  }[];
}): string => {
  const matchedSelection = selections.find(
    selection => selection.value === value,
  );
  return matchedSelection?.label || value;
};

export const getLabelsFromClassSizeValues = (
  values: Exclude<ClassSizeLearnerAttribute, "group">[],
): string[] => {
  return values.map(s =>
    getLabelFromValue({ value: s, selections: CLASS_SIZE_SELECTIONS }),
  );
};
